import { create } from "zustand";
const useAppStore = create()((set) => ({
  app: null,
  setApp: (app) => {
    set({ app });
  }
}));
const useApp = () => {
  const app = useAppStore((s) => s.app);
  return app;
};
useApp.getState = () => {
  return useAppStore.getState().app;
};
var useApp_default = useApp;
export {
  useApp_default as default,
  useAppStore
};
